/**
 * @file This creates a pipe which enables/disables incorrect entry for dates, datetimes, times and durations.
 */
export default function createAutoCorrectedDateTimePipe(format, duration) {
    if (duration === void 0) { duration = false; }
    function dateTimePipe(conformedValue) {
        var indexesOfPipedChars = [];
        var formatArray = format.toLowerCase().split(/[^dmyhi]+/);
        var maxValue = { 'dd': 31, 'mm': 12, 'yyyy': 9999, 'hh': duration ? 99 : 23, 'ii': 59 };
        var minValue = { 'dd': 1, 'mm': 1, 'yyyy': 1, 'hh': 0, 'ii': 0 };
        var conformedValueArr = conformedValue.split('');
        // Check first digit
        formatArray.forEach(function (subFormat) {
            var position = format.indexOf(subFormat);
            var maxFirstDigit = parseInt(maxValue[subFormat].toString().substr(0, 1), 10);
            if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
                conformedValueArr[position + 1] = conformedValueArr[position];
                conformedValueArr[position] = 0;
                indexesOfPipedChars.push(position);
            }
        });
        // Check for invalid value
        var isInvalid = formatArray.some(function (subFormat) {
            var position = format.indexOf(subFormat);
            var length = subFormat.length;
            var textValue = conformedValue.substr(position, length).replace(/\D/g, '');
            var value = parseInt(textValue, 10);
            return value > maxValue[subFormat] || (textValue.length === length && value < minValue[subFormat]);
        });
        if (isInvalid) {
            return false;
        }
        return {
            value: conformedValueArr.join(''),
            indexesOfPipedChars: indexesOfPipedChars
        };
    }
    return dateTimePipe;
}
